import { api } from "@/App";
import { toast } from "sonner";

export async function descargarDocumento(casoId, doc) {
  try {
    const response = await api.get(`/casos/${casoId}/documentos/${doc.id}/descargar`, {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', doc.nombre_archivo_original);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    toast.success('Documento descargado');
  } catch (error) {
    let detail = '';
    const data = error.response?.data;
    if (data instanceof Blob) {
      try {
        detail = JSON.parse(await data.text()).detail || '';
      } catch { detail = ''; }
    } else if (data?.detail) {
      detail = data.detail;
    }

    if (detail.startsWith('ARCHIVO_PERDIDO')) {
      toast.error(
        `El archivo "${doc.nombre_archivo_original}" ya no existe en el servidor. Debes volver a subirlo.`,
        { duration: 9000 }
      );
    } else if (error.response?.status === 404) {
      toast.error('Documento no encontrado');
    } else {
      toast.error('Error descargando archivo');
    }
    console.error(error);
  }
}
